import { Action } from '@ngrx/store';
import { FinancialDocument } from '../models/financial-document.model';
import { CheckedDocuments } from '.';

export enum ActionTypes {
    ADD_CHECKED_DOCUMENT                    = '[Checked Financial Documents Page] Add Checked Document',
    REMOVE_CHECKED_DOCUMENT                 = '[Checked Financial Documents Page] Remove Checked Document',
    ADD_CHECKED_DOCUMENTS                   = '[Checked Financial Documents Page] Add Checked Documents',
    REMOVE_CHECKED_DOCUMENTS                = '[Checked Financial Documents Page] Remove Checked Documents',
    CLEAR_CHECKED_DOCUMENTS                 = '[Checked Financial Documents Page] Clear Checked Documents',
    CHECK_DOCUMENTS                         = '[Checked Financial Documents Page] Check Documents',
    UNCHECK_DOCUMENTS                       = '[Checked Financial Documents Page] Uncheck Documents',

    INSPECT_CHECKED_DOCUMENTS         = '[Checked Financial Documents Error] Inspect Checked Documents',
    FLAG_BLOCKED_DOCUMENTS            = '[Checked Financial Documents Error] Flag Blocked Documents',
    FLAG_CREDITS_SELECTED             = '[Checked Financial Documents Error] Flag Credits Selected',
    FLAG_NOT_SPECIAL_INVOICES         = '[Checked Financial Documents Error] Flag Not Special Invoices',
    FLAG_CREATION_DATE_OUTSIDE_LIMIT  = '[Checked Financial Documents Error] Flag Creation Date Outside Limit',
    FLAG_MULTIPLE_COMPANIES           = '[Checked Financial Documents Error] Flag Multiple Companies',
    FLAG_MULTIPLE_JOBSITES            = '[Checked Financial Documents Error] Flag Multiple Jobsites',
    FLAG_UNPAYABLE_COMPANIES          = '[Checked Financial Documents Error] Flag Unpayable Companies',
    FLAG_UNPAYABLE_DOCUMENTS          = '[Checked Financial Documents Error] Flag Unpayable Documents',
    FLAG_DIFFERENT_TAX_RATES          = '[Checked Financial Documents Error] Flag Different Tax Rates',
    FLAG_INVALID_COMPANIES_CLEARING   = '[Checked Financial Documents Error] Flag Invalid Companies For Clearing',
    FLAG_INVALID_DOCUMENTS_CLEARING   = '[Checked Financial Documents Error] Flag Invalid Documents For Clearing',
    FLAG_INVALID_TAX_RATES_CLEARING   = '[Checked Financial Documents Error] Flag Invalid Tax Rates For Clearing',
    FLAG_INVALID_COMPANIES_DISPUTING  = '[Checked Financial Documents Error] Flag Invalid Companies For Disputing'
}

export class CheckDocuments implements Action {
    readonly type: string = ActionTypes.CHECK_DOCUMENTS;

    constructor(public payload?: any) {}
}

export class UncheckDocuments implements Action {
    readonly type: string = ActionTypes.UNCHECK_DOCUMENTS;

    constructor(public payload?: any) {}
}

export class AddCheckedDocument implements Action {
    readonly type: string = ActionTypes.ADD_CHECKED_DOCUMENT;

    constructor(public payload: FinancialDocument) {}
}

export class RemoveCheckedDocument implements Action {
    readonly type: string = ActionTypes.REMOVE_CHECKED_DOCUMENT;

    constructor(public payload: number) {}
}

export class AddCheckedDocuments implements Action {
    readonly type: string = ActionTypes.ADD_CHECKED_DOCUMENTS;

    constructor(public payload: FinancialDocument[]) {}
}

export class RemoveCheckedDocuments implements Action {
    readonly type: string = ActionTypes.REMOVE_CHECKED_DOCUMENTS;

    constructor(public payload: number[]) {}
}

export class ClearCheckedDocuments implements Action {
    readonly type: string = ActionTypes.CLEAR_CHECKED_DOCUMENTS;

    constructor(public payload: any = null) {}
}

export class InspectCheckedDocuments implements Action {
    readonly type: string = ActionTypes.INSPECT_CHECKED_DOCUMENTS;

    constructor(public payload?: any) {}
}

export class FlagBlockedDocuments implements Action {
    readonly type: string = ActionTypes.FLAG_BLOCKED_DOCUMENTS;

    constructor(public payload: boolean) {}
}

export class FlagCreationDateOutsideLimit implements Action {
    readonly type: string = ActionTypes.FLAG_CREATION_DATE_OUTSIDE_LIMIT;

    constructor(public payload: boolean) {}
}

export class FlagCreditsSelected  implements Action {
    readonly type: string = ActionTypes.FLAG_CREDITS_SELECTED;

    constructor(public payload: boolean) {}
}

export class FlagDifferentTaxRates implements Action {
    readonly type: string = ActionTypes.FLAG_DIFFERENT_TAX_RATES;

    constructor(public payload: boolean) {}
}

export class FlagInvalidCompaniesForClearing implements Action {
    readonly type: string = ActionTypes.FLAG_INVALID_COMPANIES_CLEARING;

    constructor(public payload: boolean) {}
}

export class FlagInvalidDocumentsForClearing implements Action {
    readonly type: string = ActionTypes.FLAG_INVALID_DOCUMENTS_CLEARING;

    constructor(public payload: boolean) {}
}

export class FlagInvalidTaxRatesForClearing implements Action {
    readonly type: string = ActionTypes.FLAG_INVALID_TAX_RATES_CLEARING;

    constructor(public payload: boolean) {}
}

export class FlagInvalidCompaniesForDisputing implements Action {
    readonly type: string = ActionTypes.FLAG_INVALID_COMPANIES_DISPUTING;

    constructor(public payload: boolean) {}
}

export class FlagMultipleCompanies implements Action {
    readonly type: string = ActionTypes.FLAG_MULTIPLE_COMPANIES;

    constructor(public payload: boolean) {}
}

export class FlagMultipleJobsites implements Action {
    readonly type: string = ActionTypes.FLAG_MULTIPLE_JOBSITES;

    constructor(public payload: boolean) {}
}

export class FlagUnpayableCompanies implements Action {
    readonly type: string = ActionTypes.FLAG_UNPAYABLE_COMPANIES;

    constructor(public payload: boolean) {}
}

export class FlagUnpayableDocuments implements Action {
    readonly type: string = ActionTypes.FLAG_UNPAYABLE_DOCUMENTS;

    constructor(public payload: boolean) {}
}

export class FlagNotSpecialInvoices implements Action {
    readonly type: string = ActionTypes.FLAG_NOT_SPECIAL_INVOICES;

    constructor(public payload: boolean) {}
}

export type Actions =
    | AddCheckedDocument
    | RemoveCheckedDocument
    | AddCheckedDocuments
    | RemoveCheckedDocuments
    | ClearCheckedDocuments
    | CheckDocuments
    | UncheckDocuments
    | InspectCheckedDocuments
    | FlagBlockedDocuments
    | FlagCreationDateOutsideLimit
    | FlagCreditsSelected
    | FlagDifferentTaxRates
    | FlagInvalidCompaniesForClearing
    | FlagInvalidDocumentsForClearing
    | FlagInvalidTaxRatesForClearing
    | FlagInvalidCompaniesForDisputing
    | FlagMultipleCompanies
    | FlagMultipleJobsites
    | FlagUnpayableCompanies
    | FlagUnpayableDocuments
    | FlagNotSpecialInvoices;
